import React from "react";

import { Typography } from "@mui/material";

function Pill({ text, color, bgcolor, background }) {
  return (
    <Typography
      color={color}
      fontSize={["1.2rem"]}
      fontWeight={500}
      lineHeight="2.4rem"
      padding="2px 1.2rem"
      borderRadius="1.6rem"
      textAlign="center"
      whiteSpace="nowrap"
      sx={{
        background: background || bgcolor
      }}
    >
      {text}
    </Typography>
  );
}

export default Pill;
